import React from 'react';
import PropTypes from 'prop-types';

// Util
import { getGivenName, getEmail, userIsInvited } from '../../../../../../../../common/users/userHelper';
import { isOwner } from '../../../../../../../../common/permissions/permissionUtil';

const UserNameDescription = ({ user }) => {
    if (userIsInvited(user)) {
        return (
            <span>
                Once they create an account, <strong>{getEmail(user)}</strong> will be able to
            </span>
        );
    }

    return (
        <span>
            <strong>{getGivenName(user)}</strong> can
        </span>
    );
};

const BoardEditorPermissionPopupDescription = (props) => {
    const { editable, permission, sharedBoard } = props;

    if (editable || !sharedBoard || isOwner(permission)) return null;

    return (
        <div className="permission-description">
            <UserNameDescription {...props} />
            <span>
                {' '}
                edit this board because it’s inside <strong>{sharedBoard.getIn(['content', 'title'])}</strong>
            </span>
        </div>
    );
};

BoardEditorPermissionPopupDescription.propTypes = UserNameDescription.propTypes = {
    editable: PropTypes.bool,
    permission: PropTypes.number,
    sharedBoard: PropTypes.object,
    user: PropTypes.object,
};

export default BoardEditorPermissionPopupDescription;
